import React, { createContext, useState, useEffect } from 'react';
import { useAppState } from '.';
import ChatAPI, { Chat, AuthenticatorsConfig } from '../chat-api';
import { DEVICE, SIZE } from '../GlobalStyle';

export interface ChatContextTypes {
  chat: Chat;
  setChat(state: any): void;
  showChat: boolean;
  setShowChat(state: any): void;
  isMobile: boolean;
  setIsMobile(state: any): void;
  isExpanded: boolean;
  setIsExpanded(state: any): void;
  user: any;
  setUser(state: any): void;
  isLoggingIn: boolean;
  setIsLoggingIn(state: any): void;
  authsConfig: AuthenticatorsConfig[];
  avatarURL: string;
  setAvatarURL(state: any): void;
}

export const ChatContext = createContext<ChatContextTypes>(null!);

const mql = window.matchMedia(DEVICE.mobile);

const ChatContextProvider: React.FC = React.memo(({children}) => {
  const chatAPI = new ChatAPI();
  const [chat, setChat] = useState<Chat>(null!);
  const [showChat, setShowChat] = useState<boolean>(false);
  const [user, setUser] = useState<{}>(null!);
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);
  const [authsConfig, setAuthsConfig] = useState<AuthenticatorsConfig[]>();
  const [avatarURL, setAvatarURL] = useState<string>();
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= SIZE.sm);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const { communicationTool } = useAppState();
  
  useEffect(() => {    
    const mqlCallback = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    }

    mql.addEventListener('change', mqlCallback);
    return () => {
      mql.removeEventListener('change', mqlCallback);
    }
  }, []);

  useEffect(() => {
    if (communicationTool?.user?.photo) {
      chatAPI.downloadPhoto(communicationTool.user.photo).then((file) => {
        setAvatarURL(file.url);
      })
    }
  }, [chatAPI, communicationTool]);

  useEffect(() => {
    chatAPI.getOrgConfig().then(res => setAuthsConfig(res.authenticatorsConfig));
  }, [chatAPI]);

  useEffect(() => {
    if (user) {
      setIsLoggingIn(false);
    }
  }, [user]);

  const contextState = {
    chat,
    setChat,
    showChat,
    setShowChat,
    isMobile,
    setIsMobile,
    isExpanded,
    setIsExpanded,
    user, 
    setUser,
    authsConfig,
    isLoggingIn, 
    setIsLoggingIn,
    avatarURL, 
    setAvatarURL
  } as ChatContextTypes;

  return (
    <ChatContext.Provider value={contextState}>
      {children}
    </ChatContext.Provider>
  );
})


export default ChatContextProvider;